import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { IS_PRODUCTION } from '../constants';

function useDatadogRecordRUM() {
  useEffect(() => {
    if (IS_PRODUCTION) {
      datadogRum.startSessionReplayRecording();
    }

    return () => {
      if (IS_PRODUCTION) {
        datadogRum.stopSessionReplayRecording();
      }
    };
  }, []);
}

export default useDatadogRecordRUM;
